import React from "react";
import { Text, Card, HStack, VStack } from "@commonsku/design-system";
import { WorkflowAutomationId, WorkflowAutomationListItem } from "../../../types";
import { FromNow } from "../../moment";
import AutomationStatusBadge from "./AutomationStatusBadge";
import AutomationEnableSwitch from "./AutomationEnableSwitch";
import AutomationEditButton from "./AutomationEditButton";
import { MODIFY_WORKFLOW_AUTOMATION_CAPABILITY_NAME } from "../WorkflowAutomationsRouter";
import { useHasCapabilities } from "../../../hooks";

export interface AutomationListItemProps {
    workflow: WorkflowAutomationListItem;
    toggling: boolean;
    onToggleActive: (workflowId: WorkflowAutomationId, active: boolean) => void;
}

const AutomationListItem = ({ workflow, toggling, onToggleActive }: AutomationListItemProps) => {
    const hasModifyWorkflowAutomationCapability = useHasCapabilities(MODIFY_WORKFLOW_AUTOMATION_CAPABILITY_NAME, true);
    const switchDisabled = !hasModifyWorkflowAutomationCapability || toggling;

    return (
        <Card.Root variant="outline">
            <Card.Body gap="2.5" padding="4">
                <HStack justify="space-between">
                    <VStack align="flex-start">
                        <Text margin="0!" fontWeight="semibold">
                            {workflow.name}
                        </Text>
                        <HStack gap="2.5" alignItems="center">
                            <AutomationStatusBadge status={workflow.active ? "Active" : "Inactive"} />
                            {workflow.last_triggered_at && (
                                <Text textStyle="sm" margin="0!" color="neutral.fg">
                                    Last triggered{" "}
                                    <FromNow value={workflow.last_triggered_at} interval={5 * 60 * 1000} />
                                </Text>
                            )}
                            {workflow.last_triggered_at && workflow.updated_by && (
                                <Text textStyle="sm" margin="0!" color="neutral.fg">·</Text>
                            )}
                            {workflow.updated_by && (
                                <Text textStyle="sm" margin="0!" color="neutral.fg">
                                    Last edited by {workflow.updated_by.name}
                                </Text>
                            )}
                        </HStack>
                    </VStack>
                    <HStack align="flex-end" alignItems="center" gap="4">
                        <AutomationEnableSwitch
                            isChecked={workflow.active}
                            disabled={switchDisabled}
                            onCheckedChange={(active) => onToggleActive(workflow.workflow_id, active)}
                        />
                        <AutomationEditButton workflowId={workflow.workflow_id} disabled={!hasModifyWorkflowAutomationCapability} />
                    </HStack>
                </HStack>
            </Card.Body>
        </Card.Root>

    );
};

export default AutomationListItem;
